<div class="container flex-container">
  <div class="custom-row">
    <div class="flex-col">
      <section class="flex-placeholder signup-saudia">
        <div class="title-text">
          <h2 class="UpdateHeading">
            {{content?.['b2b.register.registertitle']}}
          </h2>
          <p class="titleTextSub">{{content?.['b2b.register.registerdesc']}}</p>
        </div>
      </section>
    </div>
  </div>

  <section class="signup-info-cont cm-signup-info-cont">
    <div class="twoColLayout main-content">
      <div class="registerForm-title-section col">
        <h2 class="title">{{content?.['b2b.register.start']}}</h2>
        <p>{{content?.['b2b.register.startdesc']}}</p>
        <!-- <p class="link-section m-top-8x">
          {{content?.['b2b.register.saudiamemberlogin'].replace('Login','')}}<a
            class="cursor-pointer text-decoration-underline"
            (click)="login()"
            >Login</a
          >
        </p> -->
      </div>

      <div class="info-content">
        <div class="reg_dynamic_description"
          [innerHTML]="(content?.['b2b.register.registrationdetails'].replaceAll('\u003Cli\u003E','\u003Cli\u003E<p>')).replaceAll('\u003C/li\u003E\n','</p>\u003C/li\u003E</br>')"
        ></div>
        <div class="button-action">
          <button
            class="button--primary-small"
            mat-button
            routerLink="/Signup"
            (click)="continueToRegistration()"
          >
            {{content?.['b2b.register.continuetext']}}
            <mat-icon fontSet="material-symbols-outlined">arrow_forward</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </section>
</div>
